import { useEffect, useMemo } from 'react';
import { useQuery } from 'react-query';
import { useRouter } from 'next/router';
import { QUERY_KEYS } from 'constants/queryKeys';
import { emailTemplatesServices } from 'services/emailTemplates';
import { showError } from '@utils';
import { useAssignees } from 'hooks/common';
import { handleEmailTemplate, normalizeAgents } from './utils';

export const useEmailTemplateOperations = () => {
  const {
    query: { emailTemplateId },
  } = useRouter();
  const { assignees, isLoading: isAssigneesLoading } = useAssignees();

  const emailTemplateResponse = useQuery(
    [QUERY_KEYS.GET_EMAIL_TEMPLATE_KEY, emailTemplateId],
    () => emailTemplatesServices.getEmailTemplateById(emailTemplateId),
    { enabled: !!emailTemplateId }
  );

  const agents = useMemo(() => normalizeAgents(assignees), [assignees]);
  const emailTemplate = handleEmailTemplate(
    emailTemplateResponse?.data?.data,
    agents
  );

  const loading = isAssigneesLoading || emailTemplateResponse.isLoading;

  useEffect(() => {
    if (emailTemplateResponse?.error) {
      showError(emailTemplateResponse?.error);
    }
  }, [emailTemplateResponse?.error]);

  return {
    emailTemplateId,
    loading,
    emailTemplate,
    agents,
    getEmailTemplate: emailTemplateResponse.refetch,
  };
};
